/**
 * @fileoverview POST handler for the "/engagement/landing_pages/:app_group_id/custom_subdomain" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementLandingPagesAppGroupIdCustomSubdomainCacheKeys } from "./constants";
import type {
  PostEngagementLandingPagesAppGroupIdCustomSubdomainProps,
  PostLandingPagesCustomSubdomainResult,
} from "./types";

export const postLandingPagesCustomSubdomain = reactQueryMutationAdapter(
  engagementLandingPagesAppGroupIdCustomSubdomainCacheKeys,
  (
    props: PostEngagementLandingPagesAppGroupIdCustomSubdomainProps
  ): Promise<PostLandingPagesCustomSubdomainResult> => {
    return fetch(`/engagement/landing_pages/${props.appGroupId}/custom_subdomain`, "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
